import {XhrService} from "../../../../default/global/ts/xhr.service";
import {updateHeaderBasket} from "../../../../default/global/js/basket";
import {ToastService} from "../../ts/toast.service";
import {closeModal, showModal} from "../../../../default/global/js/modal";
export function initButtons() {
    const outlineButtons = document.querySelectorAll(".button--bordered");
    const newsletterBanners = document.querySelectorAll(".newsletterBanner .newsletterForm");
    const animatedButton = document.querySelectorAll(".button--animated");
    const svgString = `
        <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 0 1 1">
           <defs>
              <clipPath id="aurednik-blob-path" clipPathUnits="objectBoundingBox">
                 <path d="M0.078,0.983 C0.061,0.979,0.043,0.974,0.03,0.948 C0.017,0.92,0.015,0.876,0.013,0.835 C0.006,0.656,0.001,0.476,0,0.296 C0,0.246,0,0.194,0.011,0.151 C0.03,0.077,0.073,0.057,0.111,0.047 C0.372,0,0.636,0,0.898,0.02 C0.927,0.023,0.959,0.027,0.983,0.066 C1,0.124,0.99,0.537,0.975,0.785 C0.968,0.897,0.941,0.938,0.905,0.942 C0.638,0.969,0.311,1,0.078,0.983 L0.078,0.983" />
              </clipPath>
           </defs>
           <path d="M0.078,0.983 C0.061,0.979,0.043,0.974,0.03,0.948 C0.017,0.92,0.015,0.876,0.013,0.835 C0.006,0.656,0.001,0.476,0,0.296 C0,0.246,0,0.194,0.011,0.151 C0.03,0.077,0.073,0.057,0.111,0.047 C0.372,0,0.636,0,0.898,0.02 C0.927,0.023,0.959,0.027,0.983,0.066 C1,0.124,0.99,0.537,0.975,0.785 C0.968,0.897,0.941,0.938,0.905,0.942 C0.638,0.969,0.311,1,0.078,0.983 L0.078,0.983" fill="none" stroke-width="1.2" vector-effect="non-scaling-stroke"  style="paint-order: stroke; shape-rendering: geometricPrecision;" />
        </svg>`;
    /* const globalSVG = document.createElement("div");
     globalSVG.style.position = "absolute";
     globalSVG.style.width = "1px";
     globalSVG.style.height = "1px";
     globalSVG.style.margin = "-1px";
     globalSVG.style.padding = "0";
     globalSVG.style.border = "0";
     globalSVG.style.clip = "rect(0, 0, 0, 0)";
     globalSVG.style.clipPath = "inset(100%)";
     globalSVG.style.overflow = "hidden";
     globalSVG.innerHTML = svgString;
     document.body.appendChild(globalSVG);*/
    for (let button of outlineButtons) {
        const svgElement = new DOMParser().parseFromString(svgString, 'image/svg+xml').documentElement;
        button.insertBefore(svgElement, button.firstChild);
    }
    for (let newsletterBanner of newsletterBanners) {
        const svgElement = new DOMParser().parseFromString(svgString, 'image/svg+xml').documentElement;
        newsletterBanner.insertBefore(svgElement, newsletterBanner.firstChild);
    }
    for (let button of animatedButton) {
        const fragment = document.createDocumentFragment();
        const contentSpan = document.createElement("span");
        contentSpan.className = "content";
        const hiddenContentSpan = document.createElement("span");
        hiddenContentSpan.className = "content--hidden";
        hiddenContentSpan.setAttribute("aria-hidden","true");
        Array.from(button.childNodes).forEach((child) => {
            const clone1 = child.cloneNode(true);
            const clone2 = child.cloneNode(true);
            contentSpan.appendChild(clone1);
            hiddenContentSpan.appendChild(clone2);
        });
        fragment.appendChild(contentSpan);
        fragment.appendChild(hiddenContentSpan);
        button.innerHTML = "";
        button.appendChild(fragment);
    }
}

export function initReorderButton() {

    let reorderButton = document.getElementById('reorder-items');
    if (reorderButton) {
        let orderId = reorderButton.getAttribute('data-order-id');
        reorderButton.addEventListener('click', function () {
            XhrService.generalAjaxCall(
                'reorder_items',
                {'orderId': orderId},
                "POST",
                "json").then(
                function (response) {
                    var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                    updateHeaderBasket(doc);
                    if(response.successful){
                        showModal(document.getElementById('modalReorderConfirmed'));
                    }else{
                        showModal(document.getElementById('modalReorderError'));
                    }
                });
        });
    }
}
